import { DatePipe } from "@angular/common";
import { AccountList, Feature, PerformanceList, AccountMetadataUnit } from 'src/app/classes/entity'
import { FullValuePigService } from "src/app/services/full-value-pig.service";
import _ from 'lodash';

export abstract class HomeLiteViewModel {

  feature: Feature;

  onLoadPerformanceParameters: Array<PerformanceList> = [];
  performanceParameters: Array<PerformanceList> = [];
  groupedPerformanceParameters: any;

  startDate: Date;
  endDate: Date;

  companies: Array<AccountList> = [];

  companySelected: number;
  performanceParameterSelected: number;

  accountMetadataUnit: Array<AccountMetadataUnit> = [];
  weightUnitId: number;
  currencyUnitId: number;
  weightFieldUnit: string;
  currencyFieldUnit: string;

  isValidCompany: boolean = false;

  getDataDate: string;
  getDataDateVisibility: boolean = false;

  fullValuePigService: FullValuePigService;
  datePipe: DatePipe;

  groupPerformanceParameter() {
    this.groupedPerformanceParameters = _.groupBy(this.onLoadPerformanceParameters, 'accountId');
  }

  performanceParameterChanged(performanceParameterSelected) {
    this.performanceParameterSelected = performanceParameterSelected;
  }

  validateStartDate() {
    if (new Date(this.startDate) > new Date()) {
      this.startDate = undefined;
      return { status: false, message: 'Start date can not be greater than end date.' };
    }
    if ((this.endDate != undefined) && (new Date(this.startDate) >= new Date(this.endDate))) {
      this.startDate = undefined;
      return { status: false, message: 'Start Date cannot be equal or greater than end date' };
    }
    return { status: true, message: 'Valid start date' };
  }

  validateEndDate() {
    if (new Date(this.endDate) > new Date()) {
      this.endDate = undefined;
      return { status: false, message: 'End Date cannot be greater than today date' };
    }
    if ((this.startDate != undefined) && (new Date(this.startDate) > new Date(this.endDate))) {
      this.endDate = undefined;
      return { status: false, message: 'End Date cannot be greater than today date' };
    }
    return { status: true, message: 'Valid start date' };
  }
}
